













import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { FormField } from "@/types";
import BasePromptConfirmation from "@/components/BasePromptConfirmation";

export default defineComponent({
  name: "PromptComponent",
  components: { BasePromptConfirmation },
  props: {
    value: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const inputProps = ref<Partial<FormField>>({
      placeholder: $t("New album"),
      autofocus: true,
      class: "mb-5",
      validationMode: "passive",
    });

    const onCreated = async (inputValue: string, clearInput: () => void) => {
      try {
        loading.value = true;
        const newCategory = await providers.VaultsProvider.createCategory({
          data: { name: inputValue.trim(), userId: authUserStrict.value.id },
        });
        emit("create", newCategory);
        emit("close");
        clearInput();
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      inputProps,
      onCreated,
    };
  },
});
